import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchFacturasPorRadicar = (query) => http.get(`${api}/facturas-por-radicar`, { params: { ...query } })

export {
  fetchFacturasPorRadicar
}
